<mat-form-field
  appearance="outline"
  [class.focused]="isFocused"
  [ngClass]="{ failed: !validSnapshot || !!warning }"
  class="miq-form-input"
>
  <ng-container *ngIf="!isMaskedValue; else maskedInput">
    <textarea
      #textareaEl
      matInput
      autocomplete="no-autofill"
      (focus)="isFocused = true"
      (focusout)="isFocused = false"
      (input)="onInput(textareaEl)"
      (change)="onChange($event.target.value)"
      [required]="required"
      [placeholder]="placeholder"
      [formControl]="fc"
      [maxlength]="maxlength"
      [avoidCopyPaste]
      [avoidActions]="avoidCopyandPasteActions"
    ></textarea>
  </ng-container>
  <!-- DISPLAYED IF MASKED DATA -->
  <ng-template #maskedInput>
    <input
      matInput
      autocomplete="new-password"
      type="password"
      disabled
      [value]="currentValue"
      [avoidCopyPaste]
      [avoidAllActions]="true"
    />
  </ng-template>
</mat-form-field>
